const styles = {
  fixedBottomWrapper: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 2,
    backgroundColor: 'white',
  },
  hasFullWidth: { width: '100%' },
  zIndexModal: { zIndex: theme => theme.zIndex.modal },
}

export default styles
